import {Container as DIContainer, ContainerModule, loadModules} from '@yosmanyga/di';
import {DI as BASE_DI} from '@yosmanyga/base';
import {DI as AUTHENTICATION_FRONTEND_DI} from "@yosmanyga/authentication-frontend";
import {DI as SECURE_STORAGE_DI} from '@yosmanyga/web-secure-storage';
import {DI as DEVICE_IDENTIFIER_DI} from '@yosmanyga/web-device-identifier';
import {
    CONTROLLER_DI as CONTROLLER_CORE_DI,
    DATA_DI as DATA_CORE_DI
} from '@yosmanyga/fortaleza-core';
import {DI as CONTROLLER_DI} from '../controller/DI';

const container = new DIContainer();
loadModules(container, new ContainerModule((bind) => {
    bind('ENV').toConstantValue(import.meta.env.DEV ? 'dev' : 'prod')
    bind('PLATFORM').toConstantValue(import.meta.env.VITE_PLATFORM)
}));
loadModules(container, BASE_DI);
loadModules(container, AUTHENTICATION_FRONTEND_DI);
loadModules(container, SECURE_STORAGE_DI);
loadModules(container, DEVICE_IDENTIFIER_DI);
loadModules(container, CONTROLLER_CORE_DI);
loadModules(container, DATA_CORE_DI);
loadModules(container, CONTROLLER_DI);

export default container;
